module.exports = __webpack_public_path__ + "static/media/settingActive.b362b86e.svg";